export function isHeicConvertibleFile({type}: File): boolean {
  return !type || type?.includes('heic') || type?.includes('heif');
}
